// import React, { useState } from 'react';
// import { motion, AnimatePresence } from 'framer-motion';

// // Minimal, uni-colour Workbench component
// // Uses Tailwind CSS and Framer Motion
// // Each card has a dedicated image area (project screenshot) instead of a logo

// export default function WorkbenchMinimal() {
//   const [selected, setSelected] = useState(null);

//   // Accent colour (changeable) — single colour used across the page
//   const ACCENT = 'indigo-500';

//   const projects = [
//     {
//       id: 1,
//       title: 'V1-VERSE',
//       summary: 'Modern portfolio website built with React and Tailwind.',
//       imageUrl: 'https://via.placeholder.com/1200x675?text=V1-VERSE+Screenshot',
//       tech: ['React', 'Tailwind'],
//       date: 'Apr 2024',
//       github: 'https://github.com/V1VEK-Y4DAV/V1-VERSE.git',
//       demo: 'https://v1-verse.vercel.app'
//     },
//     {
//       id: 2,
//       title: 'Document Deduplication',
//       summary: 'Dedup system for e-office archives using hashing + NLP.',
//       imageUrl: 'https://via.placeholder.com/1200x675?text=Deduplication+Screenshot',
//       tech: ['TypeScript', 'Supabase'],
//       date: 'Nov 2025',
//       github: 'https://github.com/V1VEK-Y4DAV/Document-Deduplication-for-Archives.git',
//       demo: 'https://document-deduplication-for-archives.vercel.app'
//     },
//     {
//       id: 3,
//       title: 'JanVaani',
//       summary: 'House price prediction with scikit-learn and feature engineering.',
//       imageUrl: 'https://via.placeholder.com/1200x675?text=JanVaani+Screenshot',
//       tech: ['Python', 'scikit-learn'],
//       date: 'Mar 2023',
//       github: 'https://github.com/V1VEK-Y4DAV/JanVaani-Public-Complaints-Management-Hub.git',
//       demo: 'https://jan-vaani-public-complaints-managem.vercel.app'
//     }
//     // add more projects following the same shape
//   ];

//   const container = {
//     hidden: { opacity: 0 },
//     visible: { opacity: 1, transition: { staggerChildren: 0.06 } }
//   };

//   const card = {
//     hidden: { opacity: 0, y: 18 },
//     visible: { opacity: 1, y: 0, transition: { duration: 0.45, ease: 'easeOut' } },
//     hover: { y: -6, boxShadow: '0 12px 30px rgba(15, 23, 42, 0.12)', transition: { duration: 0.28 } }
//   };

//   const modal = {
//     hidden: { opacity: 0, y: 20, scale: 0.98 },
//     visible: { opacity: 1, y: 0, scale: 1, transition: { duration: 0.22 } },
//     exit: { opacity: 0, y: 10, scale: 0.98, transition: { duration: 0.18 } }
//   };

//   return (
//     <div className="min-h-screen bg-slate-50 text-slate-900 p-6">
//       <div className="max-w-6xl mx-auto">
//         {/* Header */}
//         <header className="mb-8">
//           <motion.h1
//             initial={{ opacity: 0, y: 6 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ duration: 0.45 }}
//             className="text-3xl md:text-4xl font-semibold"
//           >
//             <span className={`text-${ACCENT}`}>Project Workbench</span>
//           </motion.h1>
//           <motion.p
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             transition={{ delay: 0.08 }}
//             className="mt-2 text-sm text-slate-600 max-w-2xl"
//           >
//             Minimal, single-accent UI. Clean cards with space for project screenshots. Subtle, pleasant animations.
//           </motion.p>
//         </header>

//         {/* Grid */}
//         <motion.div
//           className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
//           variants={container}
//           initial="hidden"
//           animate="visible"
//         >
//           {projects.map((p) => (
//             <motion.article
//               key={p.id}
//               className="bg-white rounded-2xl overflow-hidden border border-slate-100 flex flex-col"
//               variants={card}
//               whileHover="hover"
//               layout
//             >
//               {/* Image area: fixed aspect ratio with object-cover */}
//               <div className="relative w-full h-44 md:h-52 bg-slate-100">
//                 <motion.img
//                   src={p.imageUrl}
//                   alt={`${p.title} screenshot`}
//                   loading="lazy"
//                   className="absolute inset-0 w-full h-full object-cover"
//                   whileHover={{ scale: 1.03 }}
//                   transition={{ duration: 0.5 }}
//                 />
//                 {/* subtle top-left tag */}
//                 <div className="absolute top-3 left-3 bg-white/80 text-slate-800 text-xs px-2 py-1 rounded-md backdrop-blur">
//                   {p.date}
//                 </div>
//               </div>

//               {/* Content */}
//               <div className="p-4 flex-1 flex flex-col">
//                 <div className="flex items-start justify-between gap-3">
//                   <h3 className="text-lg font-medium leading-snug">{p.title}</h3>
//                 </div>

//                 <p className="mt-2 text-sm text-slate-600 flex-1">{p.summary}</p>

//                 <div className="mt-4 flex items-center justify-between gap-3">
//                   <div className="flex items-center gap-2">
//                     {p.tech.slice(0, 3).map((t, i) => (
//                       <span key={i} className="text-xs bg-slate-100 px-2 py-1 rounded-md text-slate-700">
//                         {t}
//                       </span>
//                     ))}
//                   </div>

//                   <div className="flex items-center gap-2">
//                     <button
//                       onClick={() => setSelected(p)}
//                       className={`inline-flex items-center gap-2 text-sm font-medium px-3 py-1.5 rounded-lg bg-${ACCENT} text-white shadow-sm`}
//                     >
//                       View
//                     </button>

//                     <a
//                       href={p.demo}
//                       target="_blank"
//                       rel="noopener noreferrer"
//                       className="text-sm text-slate-500 hover:text-slate-700"
//                     >
//                       Live
//                     </a>
//                   </div>
//                 </div>
//               </div>
//             </motion.article>
//           ))}
//         </motion.div>

//         {/* Footer */}
//         <div className="mt-8 text-center">
//           <p className="text-sm text-slate-500">Want a different accent color or tighter spacing? Tell me which colour and I’ll update it.</p>
//         </div>
//       </div>

//       {/* Modal */}
//       <AnimatePresence>
//         {selected && (
//           <motion.div
//             className="fixed inset-0 z-50 flex items-center justify-center p-6 bg-black/40"
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//             onClick={() => setSelected(null)}
//           >
//             <motion.div
//               className="bg-white rounded-2xl max-w-3xl w-full mx-auto overflow-hidden"
//               variants={modal}
//               initial="hidden"
//               animate="visible"
//               exit="exit"
//               onClick={(e) => e.stopPropagation()}
//             >
//               <div className="md:flex">
//                 <div className="md:w-1/2">
//                   <img src={selected.imageUrl} alt={`${selected.title} large`} className="w-full h-56 md:h-full object-cover" />
//                 </div>
//                 <div className="p-6 md:w-1/2">
//                   <div className="flex justify-between items-start">
//                     <div>
//                       <h2 className="text-2xl font-semibold">{selected.title}</h2>
//                       <p className="text-sm text-slate-500 mt-1">{selected.date}</p>
//                     </div>
//                     <button onClick={() => setSelected(null)} className="text-slate-400 hover:text-slate-600">✕</button>
//                   </div>

//                   <p className="mt-4 text-slate-700">{selected.summary}</p>

//                   <div className="mt-4 flex flex-wrap gap-2">
//                     {selected.tech.map((t, i) => (
//                       <span key={i} className="text-xs bg-slate-100 px-2 py-1 rounded-md text-slate-700">{t}</span>
//                     ))}
//                   </div>

//                   <div className="mt-6 flex gap-3">
//                     <a href={selected.github} target="_blank" rel="noopener noreferrer" className={`inline-flex items-center gap-2 px-4 py-2 rounded-md bg-${ACCENT} text-white`}>GitHub</a>
//                     <a href={selected.demo} target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-4 py-2 rounded-md border border-slate-200 text-slate-700">Live Demo</a>
//                   </div>
//                 </div>
//               </div>
//             </motion.div>
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </div>
//   );
// }



// import React, { useState } from 'react';
// import { motion, AnimatePresence } from 'framer-motion';

// const Workbench = () => {
//   const [selectedProject, setSelectedProject] = useState(null);

//   const portfolioItems = [
//     {
//       id: 1,
//       title: "V1-VERSE",
//       category: "Web Development",
//       description: "Modern portfolio website built with React and Tailwind CSS",
//       detailedDescription: "A responsive portfolio website showcasing my skills and projects. Built with React, Tailwind CSS, and Framer Motion for smooth animations.",
//       technologies: ["React", "Tailwind", "Framer Motion"],
//       image: "https://images.unsplash.com/photo-1517694712202-14dd9538aa97?q=80&w=800&auto=format&fit=crop", // Replace with your actual project screenshots
//       date: "2024",
//       githubLink: "#",
//       demoLink: "#"
//     },
//     {
//       id: 2,
//       title: "Archive Deduplication",
//       category: "NLP / Engineering",
//       description: "Robust Document Deduplication System for E-office Archives",
//       detailedDescription: "The E-Office Deduplication Hub is an intelligent document management platform. It streamlines digital archives by automatically detecting and removing duplicate files.",
//       technologies: ["TypeScript", "Supabase", "NLP"],
//       image: "https://images.unsplash.com/photo-1558494949-ef010cbdcc48?q=80&w=800&auto=format&fit=crop",
//       date: "2025",
//       githubLink: "#",
//       demoLink: "#"
//     },
//     {
//       id: 3,
//       title: "JanVaani",
//       category: "Machine Learning",
//       description: "ML model for real estate price prediction using scikit-learn",
//       detailedDescription: "A predictive model that estimates house prices based on features like location, size, and amenities. Achieved 92% accuracy.",
//       technologies: ["Python", "Scikit-Learn", "Pandas"],
//       image: "https://images.unsplash.com/photo-1560514481-be15c7e7f48a?q=80&w=800&auto=format&fit=crop",
//       date: "2023",
//       githubLink: "#",
//       demoLink: "#"
//     },
//     {
//       id: 4,
//       title: "Smart Irrigation",
//       category: "IoT & ML",
//       description: "IoT-based automated irrigation system with ML-powered analysis",
//       detailedDescription: "An intelligent irrigation system that uses soil moisture sensors and weather data to optimize water usage.",
//       technologies: ["IoT", "TensorFlow", "Python"],
//       image: "https://images.unsplash.com/photo-1563514227147-6d2ff665a6a0?q=80&w=800&auto=format&fit=crop",
//       date: "2023",
//       githubLink: "#",
//       demoLink: "#"
//     }
//   ];

//   // Animation Variants
//   const containerVars = {
//     initial: { opacity: 0 },
//     animate: { opacity: 1, transition: { staggerChildren: 0.15 } }
//   };

//   const cardVars = {
//     initial: { opacity: 0, y: 20 },
//     animate: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.22, 1, 0.36, 1] } }
//   };

//   return (
//     <div className="min-h-screen bg-zinc-950 text-zinc-100 py-20 px-6 font-sans antialiased">
//       <div className="max-w-6xl mx-auto">
        
//         {/* Header Section */}
//         <header className="mb-20">
//           <motion.p 
//             initial={{ opacity: 0, x: -10 }}
//             animate={{ opacity: 1, x: 0 }}
//             className="text-zinc-500 uppercase tracking-widest text-xs font-semibold mb-3"
//           >
//             Project Workbench
//           </motion.p>
//           <motion.h1 
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ delay: 0.1 }}
//             className="text-5xl md:text-7xl font-light tracking-tighter"
//           >
//             Selected <span className="text-zinc-500 italic font-serif">Works.</span>
//           </motion.h1>
//         </header>

//         {/* Project Grid */}
//         <motion.div 
//           className="grid grid-cols-1 md:grid-cols-2 gap-12"
//           variants={containerVars}
//           initial="initial"
//           animate="animate"
//         >
//           {portfolioItems.map((project) => (
//             <motion.div
//               key={project.id}
//               variants={cardVars}
//               onClick={() => setSelectedProject(project)}
//               className="group cursor-pointer"
//             >
//               {/* Image Container */}
//               <div className="relative aspect-[16/10] overflow-hidden bg-zinc-900 rounded-sm mb-6">
//                 <motion.img 
//                   src={project.image} 
//                   alt={project.title}
//                   className="w-full h-full object-cover opacity-80 group-hover:opacity-100 group-hover:scale-105 transition-all duration-700 ease-out grayscale hover:grayscale-0"
//                 />
//                 <div className="absolute inset-0 border border-white/5 pointer-events-none" />
//               </div>

//               {/* Project Meta */}
//               <div className="flex justify-between items-start">
//                 <div>
//                   <h3 className="text-xl font-medium tracking-tight group-hover:text-zinc-400 transition-colors">
//                     {project.title}
//                   </h3>
//                   <p className="text-zinc-500 text-sm mt-1">{project.category}</p>
//                 </div>
//                 <span className="text-zinc-600 text-sm font-mono">{project.date}</span>
//               </div>
//             </motion.div>
//           ))}
//         </motion.div>
//       </div>

//       {/* Simplified Minimal Modal */}
//       <AnimatePresence>
//         {selectedProject && (
//           <motion.div 
//             className="fixed inset-0 z-50 flex items-center justify-center p-4"
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//           >
//             {/* Backdrop */}
//             <div 
//               className="absolute inset-0 bg-zinc-950/90 backdrop-blur-md" 
//               onClick={() => setSelectedProject(null)} 
//             />

//             {/* Modal Content */}
//             <motion.div 
//               layoutId={selectedProject.id}
//               className="relative bg-zinc-900 border border-zinc-800 max-w-3xl w-full overflow-hidden rounded-lg shadow-2xl"
//               initial={{ scale: 0.95, y: 20 }}
//               animate={{ scale: 1, y: 0 }}
//               exit={{ scale: 0.95, y: 20 }}
//             >
//               <img 
//                 src={selectedProject.image} 
//                 className="w-full h-64 object-cover border-b border-zinc-800 grayscale-0" 
//                 alt="Banner" 
//               />
              
//               <div className="p-8">
//                 <div className="flex justify-between items-center mb-6">
//                   <h2 className="text-3xl font-light">{selectedProject.title}</h2>
//                   <button 
//                     onClick={() => setSelectedProject(null)}
//                     className="text-zinc-500 hover:text-white transition-colors"
//                   >
//                     Close [×]
//                   </button>
//                 </div>

//                 <p className="text-zinc-400 leading-relaxed mb-8">
//                   {selectedProject.detailedDescription}
//                 </p>

//                 <div className="flex flex-wrap gap-2 mb-10">
//                   {selectedProject.technologies.map((tech) => (
//                     <span key={tech} className="text-[10px] uppercase tracking-widest bg-zinc-800 px-3 py-1 rounded-full text-zinc-300">
//                       {tech}
//                     </span>
//                   ))}
//                 </div>

//                 <div className="flex gap-4">
//                   <a href={selectedProject.githubLink} className="flex-1 text-center py-3 border border-zinc-700 hover:bg-zinc-100 hover:text-zinc-900 transition-all text-sm uppercase tracking-widest font-bold">
//                     Source Code
//                   </a>
//                   <a href={selectedProject.demoLink} className="flex-1 text-center py-3 bg-zinc-100 text-zinc-900 hover:bg-white transition-all text-sm uppercase tracking-widest font-bold">
//                     Live View
//                   </a>
//                 </div>
//               </div>
//             </motion.div>
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </div>
//   );
// };

// export default Workbench;













// import React, { useState } from 'react';
// import { motion, AnimatePresence } from 'framer-motion';

// const Workbench = () => {
//   const [selectedProject, setSelectedProject] = useState(null);

//   // Simple navigation function for internal links
//   const scrollToSection = (sectionId) => {
//     const section = document.getElementById(sectionId);
//     if (section) {
//       window.scrollTo({
//         top: section.offsetTop - 80, // Adjust for fixed navbar
//         behavior: 'smooth'
//       });
//     }
//   };

//   const portfolioItems = [
//     {
//       id: 1,
//       title: "V1-VERSE",
//       description: "Modern portfolio website built with React and Tailwind CSS",
//       detailedDescription: "A responsive portfolio website showcasing my skills and projects. Built with React, Tailwind CSS, and Framer Motion for smooth animations. Features a clean, professional design with interactive components and mobile-friendly layout.",
//       technologies: ["React", "Tailwind CSS", "Framer Motion", "JavaScript", "Responsive Design"],
//       image: "💻",
//       category: "Web Development",
//       bgColor: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//       hoverBgColor: "linear-gradient(135deg, #5a6fd8 0%, #6a4490 100%)",
//       date: "April 2024",
//       githubLink: "https://github.com/V1VEK-Y4DAV/V1-VERSE.git",
//       demoLink: "https://v1-verse.vercel.app"
//     },
//     {
//       id: 2,
//       title: "Document-Deduplication-for-Archives",
//       description: "Robust Document Deduplication System for E-office Archives",
//       detailedDescription: "The E-Office Deduplication Hub is an intelligent document management platform built with React, TypeScript, and Supabase. It streamlines digital archives by automatically detecting and removing duplicate files through a combination of MD5 hashing for exact matches and NLP-powered cosine similarity for content-based comparisons.",
//       technologies: ["React", "Tailwind CSS", "MD5 hashing", "Cosine Similarity", "Supabase", "TypeScript", "PLpgSQL"],
//       image: "🗄️",
//       category: "Natural Language Processing(NLP)",
//       bgColor: "linear-gradient(135deg, #a8edea 0%, #fed6e3 100%)",
//       hoverBgColor: "linear-gradient(135deg, #98ddda 0%, #edc6d3 100%)",
//       date: "November 2025",
//       githubLink: "https://github.com/V1VEK-Y4DAV/Document-Deduplication-for-Archives.git",
//       demoLink: "https://document-deduplication-for-archives.vercel.app"
//     },
//     {
//       id: 3,
//       title: "JanVaani",
//       description: "ML model for real estate price prediction using scikit-learn",
//       detailedDescription: "A predictive model that estimates house prices based on features like location, size, amenities, and market trends. Developed with Python's scikit-learn library, it incorporates regression techniques and feature engineering to achieve 92% prediction accuracy.",
//       technologies: ["Python", "scikit-learn", "Pandas", "NumPy", "Matplotlib"],
//       image: "🏠",
//       category: "Machine Learning",
//       bgColor: "linear-gradient(135deg, #4facfe 0%, #00f2fe 100%)",
//       hoverBgColor: "linear-gradient(135deg, #3f9cee 0%, #28e9c7 100%)",
//       date: "March 2023",
//       githubLink: "https://github.com/V1VEK-Y4DAV/JanVaani-Public-Complaints-Management-Hub.git",
//       demoLink: "https://jan-vaani-public-complaints-managem.vercel.app"
//     },
//     {
//       id: 4,
//       title: "Smart Irrigation System",
//       description: "IoT-based automated irrigation system with ML-powered crop analysis",
//       detailedDescription: "An intelligent irrigation system that uses soil moisture sensors and weather data to optimize water usage. Features a machine learning component that analyzes crop health from images and adjusts watering schedules accordingly. Built with Raspberry Pi, Python, and TensorFlow.",
//       technologies: ["Python", "IoT", "Machine Learning", "TensorFlow", "Raspberry Pi"],
//       image: "🌱",
//       category: "IoT & ML",
//       bgColor: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
//       hoverBgColor: "linear-gradient(135deg, #e083eb 0%, #e5475c 100%)",
//       date: "August 2023",
//       githubLink: "https://github.com/vivekyadav",
//       demoLink: "https://vivekyadav.dev"
//     },
//     {
//       id: 5,
//       title: "FarmGaze2.0",
//       description: "Data-driven crop growth prediction and optimization system",
//       detailedDescription: "A comprehensive system that collects agricultural data from various sources to predict crop yields and suggest optimal farming practices. Integrates satellite imagery, weather data, and soil composition analysis to provide actionable insights for farmers.",
//       technologies: ["Python", "Data Analysis", "ML", "Pandas", "GeoPandas"],
//       image: "🌾",
//       category: "Machine learning and Data Science",
//       bgColor: "linear-gradient(135deg, #43e97b 0%, #38f9d7 100%)",
//       hoverBgColor: "linear-gradient(135deg, #33d96b 0%, #28e9c7 100%)",
//       date: "January 2024",
//       githubLink: "https://github.com/vivekyadav",
//       demoLink: "https://vivekyadav.dev"
//     },
//     {
//       id: 6,
//       title: "PAN Card Tampering Detector",
//       description: "Full-stack web applications with modern frameworks",
//       detailedDescription: "A collection of responsive web applications built with React, Node.js, and PHP. Includes e-commerce platforms, content management systems, and real-time collaboration tools. All applications follow modern UI/UX principles and are optimized for performance.",
//       technologies: ["React", "Node.js", "PHP", "MongoDB", "Express"],
//       image: "🌐",
//       category: "Data Science and ML",
//       bgColor: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
//       hoverBgColor: "linear-gradient(135deg, #ea608a 0%, #eed130 100%)",
//       date: "Ongoing",
//       githubLink: "https://github.com/vivekyadav",
//       demoLink: "https://vivekyadav.dev"
//     },
//     {
//       id: 7,
//       title: "CPU Scheduler Simulator",
//       description: "Advanced CPU scheduling algorithms implementation with visualization",
//       detailedDescription: "This simulator visualizes various CPU scheduling algorithms including Round Robin, Priority Scheduling, and Shortest Job First. Built with C++ using SFML for graphics, it demonstrates how different algorithms handle processes with varying burst times and priorities.",
//       technologies: ["C++", "Data Structures", "Algorithms", "SFML"],
//       image: "🖥️",
//       category: "System Programming",
//       bgColor: "linear-gradient(135deg, #3a45d0 0%, #4a2a97 100%)",
//       hoverBgColor: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//       date: "May 2023",
//       githubLink: "https://github.com/vivekyadav",
//       demoLink: "https://vivekyadav.dev"
//     },
//     {
//       id: 8,
//       title: "Task Management Dashboard",
//       description: "Real-time collaborative task management platform",
//       detailedDescription: "A feature-rich task management dashboard with real-time updates, drag-and-drop functionality, and team collaboration features. Built with React, Node.js, and Socket.io for real-time communication. Includes analytics and reporting capabilities.",
//       technologies: ["React", "Node.js", "Socket.io", "MongoDB", "Express"],
//       image: "📋",
//       category: "Web Applications",
//       bgColor: "linear-gradient(135deg, #fa709a 0%, #fee140 100%)",
//       hoverBgColor: "linear-gradient(135deg, #ea608a 0%, #eed130 100%)",
//       date: "September 2023",
//       githubLink: "https://github.com/vivekyadav",
//       demoLink: "https://vivekyadav.dev"
//     }
//   ];

//   const containerVariants = {
//     hidden: { opacity: 0 },
//     visible: {
//       opacity: 1,
//       transition: { staggerChildren: 0.1 }
//     }
//   };

//   const itemVariants = {
//     hidden: { opacity: 0, y: 50 },
//     visible: {
//       opacity: 1,
//       y: 0,
//       transition: { duration: 0.6, ease: "easeOut" }
//     },
//     hover: {
//       scale: 1.03,
//       boxShadow: "0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
//       transition: { duration: 0.3 }
//     }
//   };

//   const modalVariants = {
//     hidden: { opacity: 0, scale: 0.8 },
//     visible: { 
//       opacity: 1, 
//       scale: 1,
//       transition: { 
//         duration: 0.3,
//         ease: "easeOut"
//       }
//     },
//     exit: { 
//       opacity: 0, 
//       scale: 0.8,
//       transition: { 
//         duration: 0.2,
//         ease: "easeIn" 
//       }
//     }
//   };

//   return (
//     <div className="min-h-screen py-4 px-4 sm:px-6 lg:px-8 bg-gray-900">
//       <div className="max-w-7xl mx-auto">
//         {/* Heading */}
//         <motion.div 
//           className="text-center mb-4"
//           initial={{ opacity: 0, y: 30 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.8 }}
//         >
//           <motion.h1 
//             className="text-4xl md:text-5xl font-bold text-white mb-2"
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ delay: 0.1 }}
//           >
//             <span className="bg-gradient-to-r from-cyan-400 to-emerald-400 bg-clip-text text-transparent">
//               Project Workbench
//             </span>
//           </motion.h1>
//           <motion.p 
//             className="text-lg text-gray-300 max-w-3xl mx-auto"
//             initial={{ opacity: 0, y: 20 }}
//             animate={{ opacity: 1, y: 0 }}
//             transition={{ delay: 0.2 }}
//           >
//             A collection of my best work showcasing expertise in machine learning, 
//             web development, and system programming
//           </motion.p>
//         </motion.div>

//         {/* Cards Grid */}
//         <motion.div 
//           className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-3"
//           variants={containerVariants}
//           initial="hidden"
//           animate="visible"
//         >
//           {portfolioItems.map((item) => (
//             <motion.div
//               key={item.id}
//               style={{ background: item.bgColor }}
//               className="rounded-lg overflow-hidden shadow-md transition-all h-full flex flex-col"
//               variants={itemVariants}
//               whileHover="hover"
//               layout
//             >
//               <div className="flex items-center justify-center p-3">
//                 <div className="text-5xl">{item.image}</div>
//               </div>
              
//               <div className="p-3 flex flex-col">
//                 <div className="flex justify-between items-start mb-2">
//                   <div>
//                     <span className="inline-block bg-cyan-600 text-white text-xs px-2 py-1 rounded-full mb-1">
//                       {item.category}
//                     </span>
//                     <h3 className="text-lg font-bold text-gray-900 mb-1">
//                       {item.title}
//                     </h3>
//                     <p className="text-xs text-gray-600 mb-2">{item.date}</p>
//                   </div>
//                 </div>
                
//                 <p className="text-gray-800 mb-3 text-sm leading-relaxed">
//                   {item.description}
//                 </p>
                
//                 <div className="flex flex-wrap gap-1 mb-3 mt-auto">
//                   {item.technologies.slice(0, 2).map((tech, index) => (
//                     <span 
//                       key={index}
//                       className="text-xs bg-white text-gray-700 px-2 py-1 rounded-full shadow-sm"
//                     >
//                       {tech}
//                     </span>
//                   ))}
//                   {item.technologies.length > 2 && (
//                     <span className="text-xs bg-white text-gray-700 px-2 py-1 rounded-full shadow-sm">
//                       +{item.technologies.length - 2}
//                     </span>
//                   )}
//                 </div>
                
//                 <motion.button
//                   className="w-full bg-cyan-600 text-white py-1.5 rounded-lg font-medium hover:bg-cyan-700 transition-colors duration-300 flex items-center justify-center gap-1 text-sm"
//                   whileHover={{ scale: 1.05 }}
//                   whileTap={{ scale: 0.98 }}
//                   onClick={() => setSelectedProject(item)}
//                 >
//                   <span>View Details</span>
//                   <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//                     <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
//                   </svg>
//                 </motion.button>
//               </div>
//             </motion.div>
//           ))}
//         </motion.div>

//         {/* Footer Buttons */}
//         <motion.div 
//           className="text-center mt-8 flex flex-wrap justify-center gap-3"
//           initial={{ opacity: 0, y: 30 }}
//           animate={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.8, delay: 0.5 }}
//         >
//           <motion.button
//             onClick={() => scrollToSection('contact')}
//             className="px-6 py-2.5 bg-gradient-to-r from-cyan-500 to-teal-500 text-white font-semibold rounded-full shadow-lg hover:shadow-xl transition-all duration-300 flex items-center gap-2 text-sm"
//             whileHover={{ scale: 1.05 }}
//             whileTap={{ scale: 0.95 }}
//           >
//             <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//               <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
//             </svg>
//             Start a Project
//           </motion.button>
//         </motion.div>
//       </div>

//       {/* Project Detail Modal */}
//       <AnimatePresence>
//         {selectedProject && (
//           <motion.div 
//             className="fixed inset-0 bg-black/70 backdrop-blur-sm z-50 flex items-center justify-center p-4"
//             initial={{ opacity: 0 }}
//             animate={{ opacity: 1 }}
//             exit={{ opacity: 0 }}
//             onClick={() => setSelectedProject(null)}
//           >
//             <motion.div 
//               className="bg-white rounded-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto"
//               variants={modalVariants}
//               initial="hidden"
//               animate="visible"
//               exit="exit"
//               onClick={e => e.stopPropagation()}
//             >
//               <div className="p-8">
//                 <div className="flex justify-between items-start mb-6">
//                   <div>
//                     <span className="inline-block bg-cyan-600 text-white text-sm px-4 py-1 rounded-full mb-3">
//                       {selectedProject.category}
//                     </span>
//                     <h2 className="text-3xl font-bold text-gray-900">{selectedProject.title}</h2>
//                     <p className="text-gray-600 mt-1">{selectedProject.date}</p>
//                   </div>
//                   <button 
//                     className="text-gray-500 hover:text-gray-700 transition-colors"
//                     onClick={() => setSelectedProject(null)}
//                   >
//                     <svg className="w-8 h-8" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//                       <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
//                     </svg>
//                   </button>
//                 </div>
                
//                 <div className="flex flex-col md:flex-row gap-6 mb-6">
//                   <div className="flex items-center justify-center bg-gray-100 rounded-xl p-8 md:w-1/3">
//                     <div className="text-7xl">{selectedProject.image}</div>
//                   </div>
                  
//                   <div className="md:w-2/3">
//                     <h3 className="text-xl font-semibold text-gray-900 mb-3">Project Overview</h3>
//                     <p className="text-gray-700 mb-5 leading-relaxed">
//                       {selectedProject.detailedDescription}
//                     </p>
                    
//                     <div className="mb-5">
//                       <h4 className="text-lg font-medium text-gray-900 mb-2">Technologies Used</h4>
//                       <div className="flex flex-wrap gap-2">
//                         {selectedProject.technologies.slice(0, 5).map((tech, index) => (
//                           <span 
//                             key={index}
//                             className="text-sm bg-cyan-100 text-cyan-800 px-3 py-1.5 rounded-full"
//                           >
//                             {tech}
//                           </span>
//                         ))}
//                         {selectedProject.technologies.length > 5 && (
//                           <span className="text-sm bg-cyan-100 text-cyan-800 px-3 py-1.5 rounded-full">
//                             +{selectedProject.technologies.length - 5}
//                           </span>
//                         )}
//                       </div>
//                     </div>
                    
//                     <div className="flex gap-3">
//                       <motion.a
//                         href={selectedProject.githubLink}
//                         className="flex-1 bg-gray-900 text-white py-2.5 rounded-lg text-center font-medium hover:bg-gray-800 transition-colors duration-300 flex items-center justify-center gap-2 text-sm"
//                         whileHover={{ scale: 1.02 }}
//                         whileTap={{ scale: 0.98 }}
//                       >
//                         <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
//                           <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
//                         </svg>
//                         GitHub
//                       </motion.a>
                          
//                       <motion.a
//                         href={selectedProject.demoLink}
//                         className="flex-1 bg-cyan-600 text-white py-2.5 rounded-lg text-center font-medium hover:bg-cyan-700 transition-colors duration-300 flex items-center justify-center gap-2 text-sm"
//                         whileHover={{ scale: 1.02 }}
//                         whileTap={{ scale: 0.98 }}
//                       >
//                         <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
//                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
//                           <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
//                         </svg>
//                         Live Demo
//                       </motion.a>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </motion.div>
//           </motion.div>
//         )}
//       </AnimatePresence>
//     </div>
//   );
// };

// export default Workbench;


import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const Workbench = () => {
  const [selectedProject, setSelectedProject] = useState(null);

  // Simple navigation function for internal links (keep if needed)
  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      window.scrollTo({
        top: section.offsetTop - 80,
        behavior: 'smooth'
      });
    }
  };

  // Enhanced portfolio items with real image placeholders
  const portfolioItems = [
    {
      id: 1,
      title: "V1-VERSE",
      description: "Modern portfolio website built with React and Tailwind CSS",
      detailedDescription: "A responsive portfolio website showcasing my skills and projects. Built with React, Tailwind CSS, and Framer Motion for smooth animations. Features a clean, professional design with interactive components and mobile-friendly layout.",
      technologies: ["React", "Tailwind CSS", "Framer Motion", "JavaScript", "Responsive Design"],
      imageUrl: "https://images.unsplash.com/photo-1587620962725-abab7fe55159?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1031&q=80",
      category: "Web Development",
      date: "April 2024",
      githubLink: "https://github.com/V1VEK-Y4DAV/V1-VERSE.git",
      demoLink: "https://v1-verse.vercel.app"
    },
    {
      id: 2,
      title: "Document-Deduplication",
      description: "Document deduplication for E-office archives",
      detailedDescription: "The E-Office Deduplication Hub is an intelligent document management platform built with React, TypeScript, and Supabase. It streamlines digital archives by automatically detecting and removing duplicate files through MD5 hashing and NLP-powered cosine similarity.",
      technologies: ["React", "TypeScript", "Supabase", "NLP", "Tailwind CSS"],
      imageUrl: "https://c8.alamy.com/comp/HE8F99/duplicate-stamp-sign-seal-HE8F99.jpg",
      category: "NLP",
      date: "November 2025",
      githubLink: "https://github.com/V1VEK-Y4DAV/Document-Deduplication-for-Archives.git",
      demoLink: "https://document-deduplication-for-archives.vercel.app"
    },
    {
      id: 3,
      title: "JanVaani",
      description: "ML model that hears your voice.",
      detailedDescription: "Janvaani is an ML-powered complaint management system designed to streamline issue resolution by analyzing, grouping, and prioritizing complaints. The system improves efficiency for authorities through semantic understanding and intelligent clustering of issues.",
      technologies: ["Python", "scikit-learn", "Pandas", "NumPy", "Matplotlib"],
      imageUrl: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR9J3QxrN29wEcBOEmZ5-o_6MvKOViwneZ2QA&s",
      category: "Machine Learning",
      date: "March 2023",
      githubLink: "https://github.com/V1VEK-Y4DAV/JanVaani-Public-Complaints-Management-Hub.git",
      demoLink: "https://jan-vaani-public-complaints-managem.vercel.app"
    },
    {
      id: 4,
      title: "FarmGaze",
      description: "IoT-based automated irrigation with ML crop analysis",
      detailedDescription: "An intelligent irrigation system that uses soil moisture sensors and weather data to optimize water usage. Features a machine learning component that analyzes crop health from images and adjusts watering schedules accordingly. Built with Raspberry Pi, Python, and TensorFlow.",
      technologies: ["Python", "IoT", "TensorFlow", "Raspberry Pi", "Machine Learning"],
      imageUrl: "https://images.unsplash.com/photo-1530836369250-ef72a3f5cda8?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80",
      category: "IoT & ML",
      date: "August 2023",
      githubLink: "https://github.com/vivekyadav",
      demoLink: "https://vivekyadav.dev"
    },
    {
      id: 5,
      title: "FarmGaze2.0",
      description: "Data-driven crop growth prediction system",
      detailedDescription: "A comprehensive system that collects agricultural data from various sources to predict crop yields and suggest optimal farming practices. Integrates satellite imagery, weather data, and soil composition analysis to provide actionable insights for farmers.",
      technologies: ["Python", "Data Analysis", "ML", "Pandas", "GeoPandas"],
      imageUrl: "https://images.unsplash.com/photo-1523348837708-15d4a09cfac2?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80",
      category: "Data Science",
      date: "January 2024",
      githubLink: "https://github.com/vivekyadav",
      demoLink: "https://vivekyadav.dev"
    },
    {
      id: 6,
      title: "PAN Card Tampering Detector",
      description: "Full-stack web applications with modern frameworks",
      detailedDescription: "A collection of responsive web applications built with React, Node.js, and PHP. Includes e-commerce platforms, content management systems, and real-time collaboration tools. All applications follow modern UI/UX principles and are optimized for performance.",
      technologies: ["React", "Node.js", "PHP", "MongoDB", "Express"],
      imageUrl: "https://thumbs.dreamstime.com/b/pan-id-card-income-tax-department-hand-pan-identification-id-card-income-tax-department-india-held-hand-black-174276666.jpg",
      category: "Data Science",
      date: "Ongoing",
      githubLink: "https://github.com/vivekyadav",
      demoLink: "https://vivekyadav.dev"
    },
    {
      id: 7,
      title: "CPU Scheduler Simulator",
      description: "CPU scheduling algorithms with visualization",
      detailedDescription: "This simulator visualizes various CPU scheduling algorithms including Round Robin, Priority Scheduling, and Shortest Job First. Built with C++ using SFML for graphics, it demonstrates how different algorithms handle processes with varying burst times and priorities.",
      technologies: ["C++", "Data Structures", "Algorithms", "SFML"],
      imageUrl: "https://images.unsplash.com/photo-1558494949-ef010cbdcc31?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1034&q=80",
      category: "System Programming",
      date: "May 2023",
      githubLink: "https://github.com/vivekyadav",
      demoLink: "https://vivekyadav.dev"
    },
    {
      id: 8,
      title: "Task Management Dashboard",
      description: "Real-time collaborative task management",
      detailedDescription: "A feature-rich task management dashboard with real-time updates, drag-and-drop functionality, and team collaboration features. Built with React, Node.js, and Socket.io for real-time communication. Includes analytics and reporting capabilities.",
      technologies: ["React", "Node.js", "Socket.io", "MongoDB", "Express"],
      imageUrl: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80",
      category: "Web Applications",
      date: "September 2023",
      githubLink: "https://github.com/vivekyadav",
      demoLink: "https://vivekyadav.dev"
    }
  ];

  // Animation variants
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.1 }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: "easeOut" }
    },
    hover: {
      y: -8,
      boxShadow: "0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)",
      transition: { duration: 0.2 }
    }
  };

  const modalVariants = {
    hidden: { opacity: 0, scale: 0.9 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 0.3, ease: "easeOut" }
    },
    exit: {
      opacity: 0,
      scale: 0.9,
      transition: { duration: 0.2, ease: "easeIn" }
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-12"
        >
          <h1 className="text-4xl md:text-5xl font-light text-gray-900 mb-4">
            Project Workbench
          </h1>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            A curated collection of my work — each project is an exploration of technology,
            design, and problem-solving.
          </p>
        </motion.div>

        {/* Grid */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          animate="visible"
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6"
        >
          {portfolioItems.map((item) => (
            <motion.div
              key={item.id}
              variants={itemVariants}
              whileHover="hover"
              className="bg-white rounded-lg overflow-hidden shadow-sm border border-gray-200 flex flex-col cursor-pointer"
              onClick={() => setSelectedProject(item)}
            >
              {/* Image */}
              <div className="aspect-w-16 aspect-h-9 bg-gray-100">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-48 object-cover"
                />
              </div>
              
              {/* Content */}
              <div className="p-5 flex-1 flex flex-col">
                <div className="mb-3">
                  <span className="inline-block text-xs font-medium text-indigo-600 bg-indigo-50 px-2 py-1 rounded">
                    {item.category}
                  </span>
                </div>
                <h3 className="text-lg font-semibold text-gray-900 mb-2">
                  {item.title}
                </h3>
                <p className="text-sm text-gray-600 mb-4 line-clamp-2">
                  {item.description}
                </p>
                
                {/* Tech tags */}
                <div className="flex flex-wrap gap-1 mb-4 mt-auto">
                  {item.technologies.slice(0, 3).map((tech, i) => (
                    <span
                      key={i}
                      className="text-xs bg-gray-100 text-gray-700 px-2 py-1 rounded"
                    >
                      {tech}
                    </span>
                  ))}
                  {item.technologies.length > 3 && (
                    <span className="text-xs bg-gray-100 text-gray-700 px-2 py-1 rounded">
                      +{item.technologies.length - 3}
                    </span>
                  )}
                </div>
                
                {/* View button */}
                <motion.button
                  className="w-full text-sm text-indigo-600 font-medium border border-indigo-200 bg-indigo-50 hover:bg-indigo-100 rounded-lg py-2 transition-colors"
                  whileTap={{ scale: 0.98 }}
                >
                  View Details
                </motion.button>
              </div>
            </motion.div>
          ))}
        </motion.div>

        {/* Footer CTA (optional) */}
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8, duration: 0.5 }}
          className="text-center mt-12"
        >
          <button
            onClick={() => scrollToSection('contact')}
            className="inline-flex items-center gap-2 px-6 py-3 bg-indigo-600 text-white font-medium rounded-lg hover:bg-indigo-700 transition-colors shadow-sm"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8" />
            </svg>
            Start a Project
          </button>
        </motion.div>
      </div>

      {/* Modal */}
      <AnimatePresence>
        {selectedProject && (
          <motion.div
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4"
            onClick={() => setSelectedProject(null)}
          >
            <motion.div
              variants={modalVariants}
              initial="hidden"
              animate="visible"
              exit="exit"
              className="bg-white rounded-xl max-w-4xl w-full max-h-[90vh] overflow-y-auto"
              onClick={(e) => e.stopPropagation()}
            >
              <div className="p-6 md:p-8">
                {/* Header */}
                <div className="flex justify-between items-start mb-6">
                  <div>
                    <span className="inline-block text-sm font-medium text-indigo-600 bg-indigo-50 px-3 py-1 rounded-full mb-3">
                      {selectedProject.category}
                    </span>
                    <h2 className="text-2xl md:text-3xl font-light text-gray-900">
                      {selectedProject.title}
                    </h2>
                    <p className="text-sm text-gray-500 mt-1">{selectedProject.date}</p>
                  </div>
                  <button
                    onClick={() => setSelectedProject(null)}
                    className="text-gray-400 hover:text-gray-600 transition-colors"
                  >
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                    </svg>
                  </button>
                </div>

                {/* Image and details */}
                <div className="flex flex-col md:flex-row gap-6 mb-6">
                  <div className="md:w-2/5">
                    <img
                      src={selectedProject.imageUrl}
                      alt={selectedProject.title}
                      className="w-full h-auto rounded-lg object-cover shadow-sm"
                    />
                  </div>
                  <div className="md:w-3/5">
                    <h3 className="text-lg font-medium text-gray-900 mb-3">Overview</h3>
                    <p className="text-gray-700 leading-relaxed mb-5">
                      {selectedProject.detailedDescription}
                    </p>
                    
                    <h4 className="text-md font-medium text-gray-900 mb-2">Technologies</h4>
                    <div className="flex flex-wrap gap-2 mb-6">
                      {selectedProject.technologies.map((tech, i) => (
                        <span
                          key={i}
                          className="text-sm bg-gray-100 text-gray-800 px-3 py-1.5 rounded"
                        >
                          {tech}
                        </span>
                      ))}
                    </div>

                    {/* Action buttons */}
                    <div className="flex gap-3">
                      <motion.a
                        href={selectedProject.githubLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex-1 bg-gray-900 text-white py-2.5 rounded-lg text-center font-medium hover:bg-gray-800 transition-colors flex items-center justify-center gap-2 text-sm"
                        whileHover={{ scale: 1.02 }}
                        whileTap={{ scale: 0.98 }}
                      >
                        <svg className="w-4 h-4" fill="currentColor" viewBox="0 0 24 24">
                          <path d="M12 0c-6.626 0-12 5.373-12 12 0 5.302 3.438 9.8 8.207 11.387.599.111.793-.261.793-.577v-2.234c-3.338.726-4.033-1.416-4.033-1.416-.546-1.387-1.333-1.756-1.333-1.756-1.089-.745.083-.729.083-.729 1.205.084 1.839 1.237 1.839 1.237 1.07 1.834 2.807 1.304 3.492.997.107-.775.418-1.305.762-1.604-2.665-.305-5.467-1.334-5.467-5.931 0-1.311.469-2.381 1.236-3.221-.124-.303-.535-1.524.117-3.176 0 0 1.008-.322 3.301 1.23.957-.266 1.983-.399 3.003-.404 1.02.005 2.047.138 3.006.404 2.291-1.552 3.297-1.23 3.297-1.23.653 1.653.242 2.874.118 3.176.77.84 1.235 1.911 1.235 3.221 0 4.609-2.807 5.624-5.479 5.921.43.372.823 1.102.823 2.222v3.293c0 .319.192.694.801.576 4.765-1.589 8.199-6.086 8.199-11.386 0-6.627-5.373-12-12-12z" />
                        </svg>
                        GitHub
                      </motion.a>
                      <motion.a
                        href={selectedProject.demoLink}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="flex-1 bg-indigo-600 text-white py-2.5 rounded-lg text-center font-medium hover:bg-indigo-700 transition-colors flex items-center justify-center gap-2 text-sm"
                        whileHover={{ scale: 1.02 }}
                        whileTap={{ scale: 0.98 }}
                      >
                        <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" />
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                        Live Demo
                      </motion.a>
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Workbench;